<template>
  <b-row v-if="canvasDetail">
    <b-col
      v-for="widget in canvasDetail.widgets"
      :key="widget.form_data_id"
      :md="checkGrid(widget.grid)"
    >
      <div class="canvas-widget">
        <p class="canvas-title">{{ widget.name }} | <span>{{ widget.timeframe }}</span></p>

        <!-- Canvas Text & Number -->
        <p
          v-if="widget.type === 'text' &&
            (widget.format_type === 'text' || widget.format_type === 'number')
          "
          class="canvas-text"
        >
          {{ widget.format_type === 'text' ? 'Dummy Text' : '12345' }}
        </p>

        <!-- Canvas Currency -->
        <p
          v-if="widget.type === 'text' && widget.format_type === 'currency'"
          class="canvas-currency"
        >
          Rp 999.999.999
        </p>

        <!-- Canvas Maps -->
        <img
          v-if="widget.type === 'map'"
          src="@/assets/new-form-ui/map-dummy.png"
          class="canvas-map"
        >

        <!-- Canvas Chart -->
        <dummy-canvas-chart
          v-if="
            widget.type === 'bar_chart' ||
              widget.type === 'line_chart' ||
              widget.type === 'pie_chart'
          "
          :data-component="widget"
        />

        <!-- Canvas Table -->
        <dummy-table-view
          v-if="widget.type === 'table'"
          :data-component="widget"
          :for-canvas="true"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex';
import DummyCanvasChart from '@/components/dummy/DummyCanvasChart';
import DummyTableView from '@/components/dummy/DummyTableView';

export default {
  components: {
    DummyCanvasChart,
    DummyTableView,
  },

  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      canvasDetail: null,
    };
  },

  created() {
    this.getDetail();
  },

  methods: {
    ...mapActions('jStoreCanvas', ['getDetailCanvas']),

    getDetail() {
      const req = {
        page: 1,
        limit: 10,
        filter: {
          id: [JSON.parse(this.dataComponent.info).canvas_id],
        },
      };
      this.getDetailCanvas(req).then((res) => {
        this.canvasDetail = res.data.data[0];
      });
    },

    checkGrid(val) {
      let value;

      if (val === '1x1') {
        value = '4';
      }

      if (val === '1x2') {
        value = '8';
      }

      if (val === '1x3') {
        value = '12';
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-widget {
  padding: 14px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid #f1f1f1;
  margin-bottom: 20px;

  .canvas-title {
    font-family: 'Poppins-Semibold';
    font-size: 12px;
    color: $black-3;
    margin-bottom: 10px;

    span {
      font-family: 'Poppins-Regular';
      font-size: 11px;
    }
  }

  .canvas-text {
    font-family: 'Poppins-Medium';
    font-size: 40px;
    color: $black-3;
    margin-bottom: 0;
    line-height: normal;
  }
  .canvas-currency {
    font-family: 'Poppins-Bold';
    font-size: 40px;
    color: $black-3;
    margin-bottom: 0;
    line-height: normal;
  }
  .canvas-text, .canvas-currency {
    word-break: break-word;
  }
  .canvas-map {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyCanvas.vue